// This file is part of MinIO Design System
// Copyright (c) 2023 MinIO, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
//
// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <http://www.gnu.org/licenses/>.

import * as React from "react";
import { SVGProps } from "react";

const FileWorldIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`min-icon`}
    fill={"currentcolor"}
    viewBox="0 0 256 256"
    {...props}
  >
    <g transform="translate(3283 -5016.899)">
      <path
        d="M188.5,255.974H14.5A14.5,14.5,0,0,1,0,241.475V14.5A14.5,14.5,0,0,1,14.5,0H128.833l.192.265L203,74.291V241.475a14.5,14.5,0,0,1-14.5,14.5Z"
        transform="translate(-3257 5016.924)"
        fill="#27ae9e"
      />
      <path
        d="M83.177,74.2H147.99L73.787,0V64.8a10.156,10.156,0,0,0,9.39,9.4"
        transform="translate(-3202.328 5016.899)"
        fill="#40d1c0"
      />
      <path
        d="M47.319.25A45.6,45.6,0,0,1,80.784,14.1,45.468,45.468,0,0,1,94.635,47.457,45.468,45.468,0,0,1,80.784,80.814,45.6,45.6,0,0,1,47.319,94.665,45.6,45.6,0,0,1,13.854,80.814,45.478,45.478,0,0,1,0,47.457,45.455,45.455,0,0,1,13.851,14.1,45.6,45.6,0,0,1,47.319.25ZM80.008,28.62A35.872,35.872,0,0,0,59.617,11.777,69.893,69.893,0,0,1,66.045,28.62Zm-32.8-18.84a62.915,62.915,0,0,0-8.864,18.838H56.3A67.338,67.338,0,0,0,47.207,9.779ZM10.638,56.987H26.6a81.652,81.652,0,0,1-.665-9.529,81.652,81.652,0,0,1,.665-9.529H10.638a44.973,44.973,0,0,0-1.109,9.529A44.973,44.973,0,0,0,10.638,56.987ZM14.628,66.3A35.872,35.872,0,0,0,35.019,83.138,69.893,69.893,0,0,1,28.59,66.3ZM28.59,28.617a69.69,69.69,0,0,1,6.428-16.843A35.886,35.886,0,0,0,14.628,28.617ZM47.207,85.133A67.338,67.338,0,0,0,56.3,66.3H38.343A62.915,62.915,0,0,0,47.207,85.133ZM58.29,56.987a61.67,61.67,0,0,0,.886-9.529,61.67,61.67,0,0,0-.886-9.529H36.125a81.652,81.652,0,0,0-.665,9.529,81.652,81.652,0,0,0,.665,9.529H58.287Zm1.33,26.152A35.886,35.886,0,0,0,80.01,66.3H66.048A69.69,69.69,0,0,1,59.62,83.138Zm8.2-26.152H83.776a37.873,37.873,0,0,0,1.33-9.529,37.873,37.873,0,0,0-1.33-9.529H67.819a81.651,81.651,0,0,1,.665,9.529A81.651,81.651,0,0,1,67.819,56.987Z"
        transform="translate(-3203.115 5125.821)"
        fill="#fff"
      />
    </g>
  </svg>
);

export default FileWorldIcon;
